import { useContext, useMemo, useCallback } from "react"
import PropTypes from "prop-types"
import SearchableMenu from "components/searchable-menu"
import { useAnalytics } from "connected-components/analytics"
import { DASHBOARD_EVENTS } from "connected-components/dashboard/analytics"
import OPTooltip from "components/material/tooltip"

export default function GraphTemplateSelector({ context }) {
  const { selectedTemplate, setSelectedTemplate } = useContext(context)
  const analytics = useAnalytics()

  const menuItems = useMemo(() => ([
    {
      id: "performance",
      label: "Performance",
      groupId: "model",
      groupLabel: "Risk model",
    },
  ]), [])

  const handleTemplateSelect = useCallback((selectedItem) => {
    analytics.track(DASHBOARD_EVENTS.GRAPH_TEMPLATE_SELECTED, {
      templateId: selectedItem.id,
      templateName: selectedItem.label,
    })
    setSelectedTemplate(selectedItem.id)
  }, [analytics, setSelectedTemplate])

  return <div className="graph-template-selector">
    <OPTooltip title="Performance is the only view available at this time." placement="bottom-start">
      <span>
        <SearchableMenu
          items={menuItems}
          current={selectedTemplate}
          onSelect={handleTemplateSelect}
          disabled
        />
      </span>
    </OPTooltip>
  </div>
}

GraphTemplateSelector.propTypes = {
  context: PropTypes.shape({
    selectedTemplate: PropTypes.string.isRequired,
    setSelectedTemplate: PropTypes.func.isRequired,
  }).isRequired,
}
